<script>
    import { onMount } from "svelte"
    import { firebase, firestore } from "../../firebase/firebase.js";
    import BorderLoader from "../../components/BorderLoader.svelte"
    import GrowLoader from "../../components/GrowLoader.svelte"
    import EmptyText from "../../components/EmptyText.svelte"
    import { user, userProfile } from "../../store/auth.js";
    import { liveCountries } from "../../store/shared.js";


    export let currentRoute;
    export let params;

    var lLoader = false;
    var tLoader = false;
    var rfLoader = false;
    var nLoader = false;
    var selectedLanguages = [];
    var translations = [];
    var backUpTranslations = [];
    var currentLang;
    var currentLangId = '';
    var currentCountry = null;
    var transBinding = {};
    var rLoader = false;
    var currentTransId = '';
    var searchText = '';
    var selectedCountries = {};

    $: {
        if ($liveCountries && $liveCountries.length > 0) {
            setInitialLang();
            fetchTranslation();
        }
    }

    function setInitialLang() {
        for (let i = 0; i < $liveCountries.length; i++) {
            const country = $liveCountries[i];
            if (country && country['liveLanguages'] && country['liveLanguages'].length > 0) {
                currentLangId = country['liveLanguages'][0]['code'];
                currentLang = country['liveLanguages'][0];
                currentCountry = country;
                break;
            }
        }
    }

    async function fetchTranslation() {
        try {
            var res = await firestore.collection('translations').orderBy('created_at', 'desc').get();
            if (res && res.docs && res.docs.length != 0) {
                translations = res.docs;
                backUpTranslations = [...translations]
                translations.forEach((trans) => {
                    var obj = {
                        'en': trans.data()['en'],
                        id: trans.id
                    }
                    if ($liveCountries && $liveCountries.length > 0) {
                        for (let i = 0; i < $liveCountries.length; i++) {
                            const country = $liveCountries[i];
                            var liveLangs = country['liveLanguages'];
                            var langs = {};
                            if (liveLangs && liveLangs.length > 0) {
                                for (let j = 0; j < liveLangs.length; j++) {
                                    const lang = liveLangs[j];
                                    if (trans.data()[country['id']]) {
                                        if (trans.data()[country['id']][lang['code']]) {
                                            langs[lang['code']] = trans.data()[country['id']][lang['code']]
                                        } else {
                                            langs[lang['code']] = ''
                                        }
                                    } else {
                                        langs[lang['code']] = ''
                                    }
                                }
                            }
                            obj[country['id']] = { ...langs }
                        }
                    }
                    transBinding[trans.id] = obj
                })
                transBinding = { ...transBinding }
            } else {
                translations = [];
                backUpTranslations = [];
            }
        } catch (error) {
        }
    }

    async function updateOtherLangsTrans(e, transId) {
        try {
            if (e && e.target) {
                var value = e.target.value.toString().trim();
                var currentCountryId = currentCountry['id'];
                var obj = {}
                obj[`${currentCountryId}`] = {
                    [`${currentLangId}`]: value
                }
                await firestore.collection('translations').doc(transId).set(obj, { merge: true });
            }
        } catch (error) {
        }
    }

    async function updateEnglishWord(e) {
        try {
            if (e && e.target && e.target.id) {
                var transId = e.target.id;
                await firestore.collection('translations').doc(transId).set({ en: e.target.value.toString().toLowerCase().trim() }, { merge: true });
            }
        } catch (error) {
        }
    }

    async function newTranslation() {
        if (!nLoader) {
            nLoader = true;
            await firestore.collection('translations').doc().set({
                en: 'word ' + translations.length || 1,
                created_at: new Date()
            })
            await fetchTranslation()
            nLoader = false;
        }
    }

    async function removeTrans(trans) {
        currentTransId = trans.id
        if (!rLoader && currentTransId) {
            try {
                rLoader = true;
                await firestore.collection('translations').doc(currentTransId).delete();
                rLoader = false;
                currentTransId = '';
                fetchTranslation()
            } catch (error) {
                currentTransId = ''

            }
        }
    }

    function filterTranslations() {
        if (searchText) {
            if (translations) {
                const filtered = backUpTranslations.filter(trans => trans.data()['en'].toLowerCase().search(searchText.toLowerCase()) >= 0)
                translations = [...filtered]
            }
        } else {
            translations = backUpTranslations;
        }

    }

    async function refreshTranslations() {
        rfLoader = true;
        await fetchTranslation();
        rfLoader = false;
    }

    function setCurrentCountryAndLang(e) {
        var splitted = e.target.value.split('$')
        if (splitted && splitted.length >= 2) {
            var countryId = splitted[0];
            var langId = splitted[1];

            currentLangId = langId;

            if ($liveCountries && $liveCountries.length > 0) {
                for (let i = 0; i < $liveCountries.length; i++) {
                    const country = $liveCountries[i];
                    const liveLangs = country['liveLanguages'];
                    if (country['id'] == countryId) {
                        currentCountry = country;
                        if (liveLangs && liveLangs.length > 0) {
                            currentLang = liveLangs.find(lang => lang['code'] == langId);
                        }
                        break;
                    }
                }
            }
        }
    }

</script>

<div class="wrapper">
    <div class="my_header">
        <div>
            Translation
        </div>
        <div class="d-flex">
            {#if $liveCountries && $liveCountries.length > 0}
                <select bind:value="{currentLangId}" on:change="{setCurrentCountryAndLang}" class="custom-select mr-1">
                    {#each $liveCountries as country}
                        <optgroup label="{country['emoji'] + ' ' + country['name']}">
                            {#if country['liveLanguages'] && country['liveLanguages'].length > 0}
                                {#each country['liveLanguages'] as lang}
                                    <option value="{country['id'] + '$' + lang['code']}" selected="{currentCountry['id'] + '_' + currentLangId == country['id'] + '_' + lang['code']}">{lang['name']}</option>
                                {/each}
                            {/if}
                        </optgroup>
                    {/each}
                </select>
            {/if}
            <input bind:value="{searchText}" on:input={filterTranslations} placeholder="Search english" type="text"
                class="form-control mr-1">
            <button on:click="{newTranslation}" type="button" class="btn btn-outline-info btn-sm mr-1">New</button>
            {#if rfLoader == false}
                <button on:click="{refreshTranslations}" type="button" class="btn btn-outline-primary btn-sm"><i
                    class="fa fa-sync-alt"></i></button>
            {:else}
                <button class="btn btn-outline-primary btn-sm" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Refreshing</span>
                </button>
            {/if}
        </div>
    </div>
    <div class="row no-gutters w-100 justify-content-center align-items-center flex-column">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pb-5">
            <div class="row no-gutters">
                {#if currentLang}
                    {#if currentLang.id != 'en'}
                        <div class="trans-list">
                            <div>
                                <table class="table table-bordered">
                                    <thead class="thead-light">
                                    <tr>
                                        <th scope="col">English</th>
                                        <th scope="col">{currentLang['name']}</th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {#if !tLoader}
                                            {#if translations && translations.length != 0}
                                                {#each translations as trans}
                                                    <tr class:dimmed="{rLoader && trans.id == currentTransId}">
                                                        <td><input name="{trans.id}" id="{trans.id}" on:input={updateEnglishWord} bind:value="{transBinding[trans.id]['en']}" type="text" class="card-field form-control"  aria-describedby="inputGroup-sizing-sm"></td>
                                                        <td><input name="{trans.id}" id="{trans.id}" on:input={(e) => updateOtherLangsTrans(e, trans.id)} bind:value="{transBinding[trans.id][currentCountry['id']][currentLangId]}" type="text" class="card-field form-control"  aria-describedby="inputGroup-sizing-sm"></td>
                                                        <td>
                                                            {#if rLoader && trans.id == currentTransId}
                                                                <div class="d-flex justify-content-center">
                                                                    <button type="button" class="btn btn-outline-danger btn-sm">
                                                                        <span class="spinner-border text-danger spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                        <span class="sr-only">Saving...</span>
                                                                    </button>
                                                                </div>
                                                            {:else}
                                                                <div class="d-flex justify-content-center">
                                                                    <button on:click="{removeTrans(trans)}" type="button" class="btn btn-outline-danger btn-sm"><span class="fa fa-trash-alt"></span></button>
                                                                </div>
                                                            {/if}
                                                            
                                                        </td>
                                                    </tr>
                                                {/each}
                                            {:else}
                                                <tr>
                                                    <td colspan="3"><EmptyText msg="No translations" /></td>
                                                </tr>
                                            {/if}
                                        {:else}
                                            <tr>
                                                <td colspan="3"><GrowLoader /></td>
                                            </tr>
                                        {/if}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    {:else}
                        <div class="mt-5 w-100">
                            <EmptyText msg="No translations needed (English to English)" />
                        </div>
                    {/if}
                {/if}
            </div>
        </div>        
    </div>
</div>

<style>
    .wrapper{
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .trans-list{
        width: 100% !important;
    }

    .dimmed {
        opacity: 0.5;
        cursor: wait;
    }

    table,
    thead,
    tr,
    tbody,
    th,
    td {
    text-align: center;
    }

    .table td {
    text-align: center;
    }

    .my_header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
</style>